
import Vue from "vue";
import AppAssessmentListingFilterHeader from "@/components/recruiter/app_assessment/AppAssessmentListingFilterHeader.vue";
import GoBackHeader from "@/components/shared/GoBackHeader.vue";
import { AppAssessments } from "@/interfaces/data_objects/app_assessments";
import { AppAssessmentNames } from "@/store/modules/common/interfaces";
import { mapActions, mapGetters, mapMutations } from "vuex";
import DeleteItem from "@/components/shared/DeleteItem.vue";
import {
  APP_ASSESSMENTS,
  SITE_DIRECTION
} from "@/store/modules/common/constants";
import { AssessmentListingHeaderOptions } from "@/interfaces/responses/assessments/assessments";
import {
  ACTIVE_ASSESSMENT,
  APP_AI_ASSESSMENT_LISTING,
  RESET_AI_ASSESSMENT,
  APPROVE_ASSESSMENT_RESUME,
  REJECT_ASSESSMENT_RESUME
} from "@/store/modules/recruiter/constants";
import { SiteDirections } from "@/store/modules/common/interfaces";
import {
  format_date,
  get_app_assessment_status,
  get_app_assessment_status_color,
  get_color_for_percentage,
  get_pass_or_fail_class,
  assessment_pass_fail_result
} from "@/utils/global";
import { get_color_by_name } from "@/utils/colors";
import DataNotFound from "@/components/shared/DataNotFound.vue";
import { ROOT_ERROR, ROOT_NOTIFICATION } from "@/store/modules/root/constants";
import { AppAiAssessmentListing } from "@/store/modules/recruiter/interfaces";
import { User } from "@/interfaces/data_objects/user";
import OnBoardingInvitationCard from "@/components/recruiter/OnBoardingInvitationCard.vue";
import { USER_DETAILS_BY_ID } from "@/store/modules/auth/constants";
import RefreshButton from "@/components/shared/RefreshButton.vue";
import { AI_ASSESSMENT_SORT_CONFIG } from "../../../../utils/assessment_sort_config";

export default Vue.extend({
  name: "AppAiAssessmentReport",
  components: {
    AppAssessmentListingFilterHeader,
    GoBackHeader,
    DataNotFound,
    DeleteItem,
    OnBoardingInvitationCard,
    RefreshButton
  },
  data() {
    return {
      loading: false, // Loading state of the page
      data_error: false, // Error state of the page
      assessments: [] as AppAssessments.Assessment[],
      table_headers: [
        {
          title: this.$t("assessments.ai-listing.col-1").toString(),
          cols: 1,
          direction: "asc"
        },
        {
          title: this.$t("assessments.ai-listing.col-2").toString(),
          cols: 2,
          sortable: true,
          direction: "desc"
        },
        { title: this.$t("assessments.ai-listing.col-3").toString(), cols: 2 },
        {
          title: this.$t("assessments.ai-listing.col-5").toString(),
          cols: 2,
          sortable: true,
          direction: "asc"
        },
        { title: this.$t("assessments.ai-listing.col-6").toString(), cols: 3 },
        {
          title: this.$t("assessments.ai-listing.col-7").toString(),
          cols: 1,
          is_btn: true
        }
      ] as AssessmentListingHeaderOptions[],
      delete_icon: require("@/assets/icons/bold/reset.svg"),
      is_delete: false,
      selected_user: {
        id: 0,
        last_name: "",
        first_name: "",
        avatar_uri: ""
      } as AppAssessments.AssessmentUserObject,
      selected_assessment: null as AppAssessments.AiAssessmentResults | null,
      delete_btn_loading: false,
      on_boarding_invitation: false,
      user_object: {} as User,
      status: "",
      sort_index: 3,
      sort_field_config: AI_ASSESSMENT_SORT_CONFIG
    };
  },
  watch: {
    "CurrentAssessment.selected_dates.date_filter": function (
      new_value: string[],
      old_value: string[]
    ) {
      if (
        (new_value.length === 2 || new_value.length === 0) &&
        new_value.length !== old_value.length
      )
        this.process_assessment_listing(1);
    },
    "CurrentAssessment.selected_candidates": function (
      new_value: string[],
      old_value: string[]
    ) {
      if (JSON.stringify(new_value) !== JSON.stringify(old_value))
        this.process_assessment_listing(1);
    },
    get_site_direction() {
      this.table_headers = [
        {
          title: this.$t("assessments.ai-listing.col-1").toString(),
          cols: 1,
          sortable: true,
          direction: "asc"
        },
        {
          title: this.$t("assessments.ai-listing.col-2").toString(),
          cols: 2,
          sortable: true,
          direction: "asc"
        },
        { title: this.$t("assessments.ai-listing.col-3").toString(), cols: 2 },
        {
          title: this.$t("assessments.ai-listing.col-5").toString(),
          cols: 3,
          sortable: true,
          direction: "asc"
        },
        { title: this.$t("assessments.ai-listing.col-6").toString(), cols: 3 },
        {
          title: this.$t("assessments.ai-listing.col-7").toString(),
          cols: 1,
          is_btn: true
        }
      ];
    },
    app_assessments: {
      handler(newVal) {
        console.log(
          "AiReport: app_assessments watcher triggered, length:",
          newVal ? newVal.length : 0
        );
        this.init_process();
      },
      immediate: true
    }
  },
  computed: {
    SiteDirections() {
      return SiteDirections;
    },
    ...mapGetters("common", {
      app_assessments: APP_ASSESSMENTS,
      get_site_direction: SITE_DIRECTION
    }),
    ...mapGetters("recruiter", {
      app_ai_assessment_listing: APP_AI_ASSESSMENT_LISTING
    }),
    not_found_error() {
      return this.$t("errors.ai-assessments-not-found").toString();
    },
    AppAssessmentsStatus() {
      return AppAssessments.AppAssessmentStatus;
    },
    CurrentAssessment(): AppAiAssessmentListing {
      return this.app_ai_assessment_listing();
    }
  },
  async mounted() {
    console.log("AiReport: mounted");
    this.init_process();
  },
  methods: {
    format_date,
    get_app_assessment_status,
    get_app_assessment_status_color,
    get_color_for_percentage,
    get_pass_or_fail_class,
    assessment_pass_fail_result,
    ...mapActions("recruiter", {
      fetch_ai_assessment_listing: APP_AI_ASSESSMENT_LISTING,
      reset_ai_assessment: RESET_AI_ASSESSMENT
    }),
    ...mapActions("common", {
      fetch_app_assessments: APP_ASSESSMENTS
    }),
    ...mapMutations("recruiter", {
      set_active_assessment: ACTIVE_ASSESSMENT
    }),
    ...mapMutations({
      set_root_notification: ROOT_NOTIFICATION,
      set_root_error: ROOT_ERROR
    }),
    ...mapActions("auth", {
      fetch_user_by_id: USER_DETAILS_BY_ID
    }),
    ...mapActions("common", {
      fetch_app_assessments: APP_ASSESSMENTS
    }),
    async init_process() {
      console.log("AiReport: init_process started");
      this.loading = true;
      this.data_error = false;

      // If assessments are not loaded yet, fetch them
      if (!this.app_assessments || this.app_assessments.length === 0) {
        console.log("AiReport: app_assessments empty, fetching common data...");
        await this.fetch_app_assessments();
      }

      console.log("AiReport: app_assessments in store:", this.app_assessments);
      const staticAsssessments = Object.values(AppAssessmentNames).map(
        (val: string) => val
      );
      this.assessments = this.app_assessments.filter(
        (val: AppAssessments.Assessment) =>
          !staticAsssessments.includes(val.assessment_type.toString())
      );
      console.log("AiReport: filtered dynamic assessments:", this.assessments);
      // If assessment is not found
      if (!this.assessments.length) {
        console.warn(
          "AiReport: no dynamic AI assessments found locally, attempting fetch anyway..."
        );
        // Don't return here, let the listing API decide if there are results
      }
      console.log("AiReport: triggering backend results fetch...");

      await this.fetch_assessment_by_pagination(
        this.CurrentAssessment.page,
        this.CurrentAssessment.limit
      );
    },
    async process_assessment_listing(page: number) {
      console.log("AiReport: process_assessment_listing called, page:", page);
      if (!this.assessments.length) {
        console.warn("AiReport: assessments list empty, aborting process");
        return;
      }
      await this.fetch_assessment_by_pagination(
        page,
        this.CurrentAssessment.limit
      );
    },
    async fetch_assessment_by_pagination(page = 1, limit: number) {
      console.log("AiReport: fetch_assessment_by_pagination called", {
        page,
        limit
      });
      this.loading = true;
      const assessment_ids = this.assessments.map(
        (assessment: AppAssessments.Assessment) => assessment.id
      );
      const res = await this.fetch_ai_assessment_listing({
        page,
        limit,
        assessment_ids,
        selected_dates: this.CurrentAssessment.selected_dates,
        selected_candidates: this.CurrentAssessment.selected_candidates,
        score_filter: this.CurrentAssessment.score_filter,
        status_filter: this.CurrentAssessment.status_filter,
        sort_by: this.CurrentAssessment.sort_by,
        sort_order: this.CurrentAssessment.sort_order
      });
      if (!res) {
        console.error(
          "AiReport: fetch_ai_assessment_listing returned false (error)"
        );
        this.data_error = true;
        this.loading = false;
        return;
      }
      this.loading = false;
    },
    transform_view_icon(icon: HTMLElement): HTMLElement {
      const color = get_color_by_name("success");
      for (let node of icon.children) node.setAttribute("stroke", color);
      return icon;
    },
    view_assessment_result(assessment_id: number, user_id: number) {
      this.$router.push(
        `/recruiter/assessments/ai/${assessment_id}/view/${user_id}`
      );
    },
    transform_trash_icon(icon: HTMLElement): HTMLElement {
      const color = "#FF4066";
      for (let node of icon.children) node.setAttribute("stroke", color);
      return icon;
    },
    delete_assessment(assessment: AppAssessments.AiAssessmentResults) {
      this.selected_user = assessment.user;
      this.selected_assessment = assessment;
      this.delete_btn_loading = false;
      this.is_delete = true;
    },
    async dialog_action(value: boolean) {
      if (value) {
        this.delete_btn_loading = true;
        const response = await this.reset_ai_assessment({
          assessment_id: this.selected_assessment?.assessment?.id,
          user_id: this.selected_user.id
        });
        if (response) {
          this.set_root_notification(
            `${this.selected_user.first_name} ${
              this.selected_user.last_name
            } ${this.$t("assessments.assessment-reset")}`
          );
          this.process_assessment_listing(1);
        } else {
          this.set_root_error(
            `${this.selected_user.first_name} ${
              this.selected_user.last_name
            } ${this.$t("assessments.assessment-reset-failed")}`
          );
        }
        this.is_delete = false;
      }
    },
    update_filter(filter: string) {
      this.CurrentAssessment.score_filter = filter;
      this.process_assessment_listing(1);
    },
    async sort_assessment(ind: number) {
      this.table_headers[ind].direction =
        this.table_headers[ind].direction === "asc" ? "desc" : "asc";
      const sortField = this.sort_field_config[ind];

      if (sortField) {
        this.CurrentAssessment.sort_by = sortField;
        this.CurrentAssessment.sort_order = this.table_headers[ind].direction;

        await this.fetch_assessment_by_pagination(
          this.CurrentAssessment.page,
          this.CurrentAssessment.limit
        );
      }
    },
    async open_user_details(
      user: AppAssessments.AssessmentUserObject,
      status: AppAssessments.AppAssessmentStatus | null
    ) {
      const response = await this.fetch_user_by_id(user.id);
      if (response) {
        this.user_object = response;
        this.on_boarding_invitation = true;
        this.status = status || "";
      }
    },
    update_status_filter(filter: string) {
      this.CurrentAssessment.status_filter = filter;
      this.process_assessment_listing(1);
    },
    get_status_label(assessment: AppAssessments.AiAssessmentResults) {
      // "Left Incomplete" only when candidate left without submitting (IN_PROGRESS + PENDING approval).
      // RESULT_PROCESSING = candidate submitted; show "Result Processing" even before score is computed.
      if (
        assessment.status === AppAssessments.AppAssessmentStatus.IN_PROGRESS &&
        assessment.resume_admin_status === "PENDING"
      ) {
        return this.$t("assessments.left-incomplete").toString();
      }
      return assessment.status
        ? this.get_app_assessment_status(
            assessment.status || AppAssessments.AppAssessmentStatus.IN_PROGRESS
          )
        : "";
    },
    can_approve_resume(assessment: AppAssessments.AiAssessmentResults) {
      // Show Approve/Reject Resume only for "Left Incomplete" (candidate left without submitting, PENDING approval).
      // Do not show for "Result Processing" (candidate has submitted).
      return (
        assessment.status === AppAssessments.AppAssessmentStatus.IN_PROGRESS &&
        assessment.resume_admin_status === "PENDING"
      );
    },
    async approve_resume(assessment: AppAssessments.AiAssessmentResults) {
      const ok = (await this.$store.dispatch(
        "recruiter/" + APPROVE_ASSESSMENT_RESUME,
        assessment.id
      )) as boolean;
      if (ok) {
        this.set_root_notification(
          this.$t("assessments.resume-approved").toString()
        );
        this.refresh_listing();
      } else {
        this.set_root_error(
          this.$t("assessments.resume-approve-failed").toString()
        );
      }
    },
    async reject_resume(assessment: AppAssessments.AiAssessmentResults) {
      const ok = (await this.$store.dispatch(
        "recruiter/" + REJECT_ASSESSMENT_RESUME,
        assessment.id
      )) as boolean;
      if (ok) {
        this.set_root_notification(
          this.$t("assessments.resume-rejected").toString()
        );
        this.refresh_listing();
      } else {
        this.set_root_error(
          this.$t("assessments.resume-reject-failed").toString()
        );
      }
    },
    get_percentage(
      assessment: AppAssessments.AiAssessmentResults
    ): number | null {
      if (
        assessment.result &&
        assessment.result.overall_score !== null &&
        assessment.result.overall_score !== undefined
      ) {
        const rawScore = assessment.result.overall_score;
        const parsedScore =
          typeof rawScore === "string" ? parseFloat(rawScore) : rawScore;
        if (isNaN(parsedScore)) {
          return null;
        }
        // Cap percentage at 100% to ensure scores are out of 100%
        return Math.min(parsedScore, 100);
      }
      return null;
    },
    check_status(assessment: AppAssessments.AiAssessmentResults) {
      if (assessment.status)
        return [
          AppAssessments.AppAssessmentStatus.IN_PROGRESS,
          AppAssessments.AppAssessmentStatus.CANCELLED,
          AppAssessments.AppAssessmentStatus.FAILED
        ].includes(assessment.status);
      return false;
    },
    format_user_name(user: AppAssessments.AssessmentUserObject) {
      const firstName = (user.first_name || "").toString().trim();
      const rawLastName = (user.last_name || "").toString().trim();
      const lastName =
        rawLastName && rawLastName.toLowerCase() !== "null" ? rawLastName : "";
      return [firstName, lastName].filter(Boolean).join(" ");
    },
    refresh_listing() {
      if (this.assessments.length)
        this.fetch_assessment_by_pagination(
          this.CurrentAssessment.page,
          this.CurrentAssessment.limit
        );
    }
  }
});
